import React from 'react';
import styled from 'styled-components';

type TagStyleComponentProps = {
  children: string
  mr?: string
}

const TagStyle = styled.span<{$mr?: string}>`
  border: 1px solid #707070;
  border-radius: 3px;
  color: #696767;
  font-size: 11px;
  white-space: nowrap;
  margin-right: ${props => props.$mr || '0'};
  padding: 2px 5px;
  height: 18px;
`;

const Tag: React.FC<TagStyleComponentProps> = ({ children, mr }) => {
  return (
    <TagStyle $mr={mr}>
      { children }
    </TagStyle>
  );
};

export default Tag;
